import { HashStraight } from '@phosphor-icons/react';

export default HashStraight;
